import client from '../plugins/client';

export default {
  /**
   * @description Get signed URL to upload to AWS S3
   * @param {'image' | 'document'} type Type of file
   * @param {string} contentType
   * @returns {Promise<import('axios').AxiosResponse<{url: string, fileName: string, method: string}>>}
   */
  async getSignedUrl(type, contentType) {
    return client.get(`/upload/${type}`, { params: { contentType } });
  },
};
